// extracted by mini-css-extract-plugin
export default {"container":"qES8Hz7aobgg33YVhlXjTw==","lottie":"Htrrt+9eD24xVJ5I9M+uYg==","textContainer":"_2t0pZ3Y25XRmmO8LZvC97g=="};